module.exports = __webpack_public_path__ + "media/assets/images/user-icon-28d63e32b6bd100f48bd2dd5f3730803.svg";